import RegistresLegacyController from './registres.controller';
import Template from './registres.html';

export default {
	controller: RegistresLegacyController,
	template: Template
};
